import React from 'react'
import PropTypes from 'prop-types'
import {useLearningCenterPage} from './useLearningCenterPage'
import {BuilderBreadcrumb} from '../breadcrumb'

export const LearningCenterBreadcrumb = (props) => {
    const {separator, builderBlock, attributes} = props

    const {crumbs} = useLearningCenterPage()

    return (
        <BuilderBreadcrumb
            crumbs={crumbs}
            builderBlock={builderBlock}
            attributes={attributes}
            separator={separator}
            data-testid="learningCenterBreadcrumb-BuilderBreadcrumb"
        />
    )
}

LearningCenterBreadcrumb.propTypes = {
    pageType: PropTypes.string,
    attributes: PropTypes.object,
    separator: PropTypes.node,
    builderBlock: PropTypes.object
}

export const LearningCenterBreadcrumbDefinition = {
    component: LearningCenterBreadcrumb,
    name: 'LearningCenterBreadcrumb',
    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    inputs: [
        {
            name: 'separator',
            type: 'string',
            defaultValue: '>',
            friendlyName: 'Breadcrumb Separator'
        }
    ]
}
